import { useState, type ReactElement } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'

import { MediaLibrary, mediaQuery, useCompleteMedia, useDeleteMedia, useSignMedia } from '~/features/help-kb'

/**
 * The media tab.
 *
 * Uploads go browser → R2 directly through a presigned URL; this page only
 * orchestrates the sign and complete calls. A delete is refused by the server
 * while a published article still references the object, which is the right
 * order of operations rather than something a click should be able to skip.
 */
export const Route = createFileRoute('/admin/help-kb/media')({
  component: HelpKbMediaPage,
})

function HelpKbMediaPage(): ReactElement {
  const list = useQuery(mediaQuery())
  const sign = useSignMedia()
  const complete = useCompleteMedia()
  const remove = useDeleteMedia()
  const [deleteError, setDeleteError] = useState<unknown>(null)

  return (
    <MediaLibrary
      media={list.data?.media ?? []}
      isLoading={list.isLoading}
      error={list.error}
      deleteError={deleteError}
      onSign={(input) => sign.mutateAsync(input)}
      onComplete={(input) => complete.mutateAsync(input)}
      onDelete={(id) => {
        setDeleteError(null)
        remove.mutate({ id }, { onError: (cause) => setDeleteError(cause) })
      }}
    />
  )
}
